import { render } from "./Tabs.vue?vue&type=template&id=c3d3c75a&scoped=true&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=c3d3c75a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d3c75a"]])

export default __exports__